<template>
  <div class="h-15 w-15">
    <div
      class="pie relative rounded-full"
      :class="color + ' bg-opacity-50'"
      :style="'--p:' + p + '; --b:2px;--c:' + borderColor + ';'"
    >
      <span class="font-normal text-lg">{{ p }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CircularGauge',
  props: {
    value: Number,
  },

  data() {
    return {
      p: 0,
    };
  },

  computed: {
    borderColor() {
      if (this.value <= 100 && this.value > 75) {
        return '#21B8C8';
      }
      if (this.value <= 75 && this.value > 50) {
        return '#3A18D1';
      }
      if (this.value <= 50 && this.value > 25) {
        return '#FF3900';
      }
      if (this.value <= 25) {
        return '#FF1C80';
      }
    },
    color() {
      if (this.value <= 100 && this.value > 75) {
        return 'bg-teal-300 text-teal-600';
      }
      if (this.value <= 75 && this.value > 50) {
        return 'bg-indigo-300 text-indigo-600';
      }
      if (this.value <= 50 && this.value > 25) {
        return 'bg-orange-300 text-orange-600';
      }
      if (this.value <= 25) {
        return 'bg-pink-300 text-pink-600';
      }
    },
  },

  watch: {},

  mounted() {
    this.slowIncrement();
  },

  methods: {
    async slowIncrement() {
      while (this.p < this.value) {
        const sleepTime = (this.p / this.value) * 50;
        await this.sleep(sleepTime);
        this.p++;
      }
    },

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
  },
};
</script>

<style>
.pie {
  --w: 100%;
  width: var(--w);
  aspect-ratio: 1;
  display: inline-grid;
  place-content: center;
}

.pie:before {
  content: '';
  position: absolute;
  border-radius: 50%;
  inset: 0;
  background: conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);
  -webkit-mask: radial-gradient(
    farthest-side,
    #0000 calc(99% - var(--b)),
    #000 calc(100% - var(--b))
  );
  mask: radial-gradient(
    farthest-side,
    #0000 calc(99% - var(--b)),
    #000 calc(100% - var(--b))
  );
}
</style>
